__turbopack_context__.v({
  "className": "iransans_e81efbe1-module__eFEevG__className",
  "variable": "iransans_e81efbe1-module__eFEevG__variable",
});
